import { z } from 'zod/v4-mini';

import { DeviceType, deviceTypeSchema } from '@/models/MedicalDeviceModel.ts';
import { Schema, cz } from '@/utils/zodUtils.ts';

export const foodSizeSchema = cz.permissiveLiteral(['light', 'medium', 'big']);
export type FoodSize = z.infer<typeof foodSizeSchema>;
export const mealSchema = z.literal(['breakfast', 'lunch', 'dinner', 'snack']);
export type Meal = z.infer<typeof mealSchema>;

export type Food = {
  id: string;
  patientId: string;
  date: string;
  deviceId?: string;
  deviceType?: DeviceType;

  size?: FoodSize;
  carbs?: number;
  comments?: string;
  meal?: Meal;
};

export const foodSchema: Schema<Food> = cz.camelCaseObject({
  id: cz.id(),
  patient_id: z.string(),
  date: cz.datetime(),
  device_id: cz.optional(cz.id()),
  device_type: cz.optional(deviceTypeSchema),
  size: cz.optional(foodSizeSchema),
  carbs: cz.optional(z.number()),
  comments: cz.optional(z.string()),
  meal: cz.optional(z.union([mealSchema, cz.ignore()])),
});

export const getFoodMealTranslation = (meal: Meal | undefined): string => {
  switch (meal) {
    case 'breakfast':
      return 'models.meal.breakfast';
    case 'lunch':
      return 'models.meal.lunch';
    case 'dinner':
      return 'models.meal.dinner';
    case 'snack':
      return 'models.meal.snack';
    default:
      return 'models.meal.unknown';
  }
};

export const getFoodSizeTranslation = (size: FoodSize | undefined): string => {
  switch (size) {
    case 'light':
      return 'models.mealSize.light';
    case 'medium':
      return 'models.mealSize.medium';
    case 'big':
      return 'models.mealSize.heavy';
    default:
      return 'models.mealSize.unknown';
  }
};
